(function () {
    'use strict';

    angular.module('app.landing')
        .component('landingTaskBar', {
            templateUrl: 'app/landingPage/landing-task-bar.html',
            controller: 'LandingTaskBarController',
            controllerAs: 'vm'
        });
})();